import { render, staticRenderFns } from "./JFileInputFile.vue?vue&type=template&id=01df35e4"
import script from "./JFileInputFile.vue?vue&type=script&lang=ts"
export * from "./JFileInputFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports